// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"346":"stores","818":"auth"}[chunkId] || chunkId) + "." + {"74":"6c1e63e0","346":"f80044e1","818":"452b68b8"}[chunkId] + ".js";
};